import { render, staticRenderFns } from "./SpecialLeagueCard.vue?vue&type=template&id=a936d76c&"
import script from "./SpecialLeagueCard.vue?vue&type=script&lang=js&"
export * from "./SpecialLeagueCard.vue?vue&type=script&lang=js&"
import style0 from "./SpecialLeagueCard.vue?vue&type=style&index=0&id=a936d76c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports